import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-analyses-id-results-metrics-servings',
  templateUrl: './servings.component.html',
})
export class AnalysesIdResultsMetricsServingsComponent implements OnInit {
  @Input() type: 'vegetables' | 'meat' = 'vegetables';
  title: string;
  servings: { src: string; translation: string }[];

  readonly vegetables = [
    {
      src: '/assets/images/servings/serving1.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.APPLE',
    },
    {
      src: '/assets/images/servings/serving2.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.BANANA',
    },
    {
      src: '/assets/images/servings/serving3.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.KIWI',
    },
    {
      src: '/assets/images/servings/serving4.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.APRICOTS',
    },
    {
      src: '/assets/images/servings/serving5.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.BERRIES',
    },
    {
      src: '/assets/images/servings/serving7.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.SULTANAS',
    },
    {
      src: '/assets/images/servings/serving9.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.BEET',
    },
    {
      src: '/assets/images/servings/serving10.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.BROCCOLI',
    },
    {
      src: '/assets/images/servings/serving11.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.STRING_BEANS',
    },
    {
      src: '/assets/images/servings/serving12.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.LETTUCE',
    },
    {
      src: '/assets/images/servings/serving13.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.TOMATO',
    },
    {
      src: '/assets/images/servings/serving14.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.SPINACH',
    },
    {
      src: '/assets/images/servings/serving15.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.BELL_PEPPER',
    },
    {
      src: '/assets/images/servings/serving16.png',
      translation: 'ANALYSES.RESULTS.METRICS.SERVINGS.BABY_CARROTS',
    },
  ];

  readonly meat = [
    {
      src: '/assets/images/servings/meat1.png',
      translation: 'ANALYSES.RESULTS.METRICS.MEAT.SALAMI',
    },
    {
      src: '/assets/images/servings/meat2.png',
      translation: 'ANALYSES.RESULTS.METRICS.MEAT.HOTDOG',
    },
    {
      src: '/assets/images/servings/meat3.png',
      translation: 'ANALYSES.RESULTS.METRICS.MEAT.SAUSAGE',
    },
    {
      src: '/assets/images/servings/meat4.png',
      translation: 'ANALYSES.RESULTS.METRICS.MEAT.PROSCIUTTO',
    },
    {
      src: '/assets/images/servings/meat5.png',
      translation: 'ANALYSES.RESULTS.METRICS.MEAT.BACON',
    },
  ];

  constructor(public readonly modal: NgbActiveModal) {}

  ngOnInit() {
    if (this.type === 'vegetables') {
      this.title = 'ANALYSES.RESULTS.METRICS.SERVINGS.TITLE';
      this.servings = this.vegetables;
    } else {
      this.title = 'ANALYSES.RESULTS.METRICS.MEAT.TITLE';
      this.servings = this.meat;
    }
  }
}
